import React, { useEffect, useState } from "react";
import { payrollApi } from "../../../lib/api";

export default function AuditHistoryTab({ periodId, employeeAdjustmentIds }) {
  const [entries, setEntries] = useState(null);
  useEffect(() => {
    if (!periodId) { setEntries([]); return; }
    payrollApi.listPeriodAudit(periodId)
      .then((rows) => {
        const idSet = new Set(employeeAdjustmentIds || []);
        setEntries(rows.filter((r) => idSet.has(r.meta?.adjustmentId)));
      })
      .catch(() => setEntries([]));
  }, [periodId, employeeAdjustmentIds]);

  if (entries === null) return <div className="text-center text-slate-400 italic py-8" data-testid="payroll-audit-history-tab">Loading…</div>;
  if (entries.length === 0) return <div className="text-center text-slate-400 italic py-8" data-testid="payroll-audit-history-tab">No audit history for this employee yet.</div>;
  return (
    <div className="space-y-2" data-testid="payroll-audit-history-tab">
      {entries.map((e) => (
        <div key={e.id} className="rounded-lg border border-slate-200 p-3 text-[12.5px]" data-testid={`audit-entry-${e.id}`}>
          <div className="flex items-center justify-between text-slate-500 text-[11px]">
            <span>{new Date(e.performedAt).toLocaleString()}</span>
            <span className="font-semibold text-slate-700">{e.performedBy}</span>
          </div>
          <div className="mt-1 font-semibold text-slate-800">{e.action}</div>
          {e.detail && <div className="text-slate-600 mt-0.5">{e.detail}</div>}
        </div>
      ))}
    </div>
  );
}
